import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';

export type GroupedEventMarkets = Record<string, Array<EventMarketItemType>>;

export const UNGROUPED_TEMPLATES: Array<string> = [
    'race-to',
    'custom-outrights-market',
    'custom-match-market',
    'custom-market',
    'custom-two-participant-market',
];

export const getDisplayTemplatePrefix = (market: EventMarketItemType): string => {
    const marketDisplayTemplate = market.tags['display-template'];
    return marketDisplayTemplate !== undefined && marketDisplayTemplate !== '-' ? `${marketDisplayTemplate}-` : '';
};
